export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '发货包件数控制',
} as TCommon.RouteConfig
